export default [{
  path: '/staff/dismissed',
  name: 'dismissed',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/staff/dissmissed')
}]
